import React, { useMemo } from 'react';
import { Country, State, IState } from 'country-state-city';

import { Select } from 'antd';

interface Props {
  value: string;
  onValueChange?: (value: string) => void;
  country?: string;
  [key: string]: unknown;
}

let allStates: IState[] = [];

export const StatesDropdown: React.FC<Props> = ({
  value,
  onValueChange,
  country,
  ...props
}) => {

  if (country) {
    const match = Country.getAllCountries().filter(
      cntry => cntry.name === country,
    );
    if (match?.length) {
      allStates = State.getStatesOfCountry(match[0].isoCode);
    }
  } else {
    allStates = State.getAllStates();
  }

  const options = useMemo(() => {
    return allStates.map(stateValue => ({
      value: stateValue.isoCode,
      label: stateValue.name,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[allStates]);

  return (
    <Select
      value={value}
      onChange={onValueChange}
      options={[{ value: '', label: '' }, ...options]}
      {...props}
    />
  );
};

StatesDropdown.defaultProps = {
  onValueChange: undefined,
  country: undefined,
};
